import React from 'react'
import { Body } from 'components/Shell/Shell'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { PinInputSection } from './Pins'
import FormCard from 'components/FormCard/FormCard'
import { SUBROUTES } from 'utilities'
import { GET_WEB_USER_ACCESS_WITH_GENERIC_PIN } from 'requests'
import Markdown from 'components/Markdown/Markdown'

const PIN_GENERIC_DESCRIPTION = process.env.PIN_GENERIC_DESCRIPTION
const PIN_NOT_LOGGED_IN_DESCRIPTION = process.env.PIN_NOT_LOGGED_IN_DESCRIPTION

class PinsPage extends React.Component {
  state = {
    pinCorrect: null,
    loading: false,
    currentPin: null,
    errorMessage: null,
    successMessage: null,
    sourceTypeId: null
  }
  checkPin = pin => {
    this.setState({ loading: true, pinCorrect: null, errorMessage: null, successMessage: null })
    GET_WEB_USER_ACCESS_WITH_GENERIC_PIN(
      pin,
      pinObject => {
        this.setState({ loading: false, pinCorrect: true, currentPin: pin, successMessage: pinObject.successMessage, sourceTypeId: pinObject.sourceTypeId })
      },
      err => {
        this.setState({ pinCorrect: false, errorMessage: err.message, loading: false })
      }
    )
  }
  getParameter = () => {
    const parameter = (SUBROUTES.find(l => l.sourceTypeId === this.state.sourceTypeId) || {})
      .parameter
    return parameter ? `/${parameter}` : ''
  }
  restart = () => {
    this.setState({pinCorrect: null, currentPin: null, errorMessage: null, sourceTypeId: null})
  }
  render() {
    const { loggedIn, location } = this.props
    return (
      <Body className="pins-page">
        <FormCard
          title={!loggedIn ? 'Enter PIN' : this.state.pinCorrect ? 'PIN Accepted' : 'Enter PIN'}
          seal
        >
          {loggedIn ? (
            <PinEntry
              successMessage={this.state.successMessage}
              checkPin={this.checkPin}
              loading={this.state.loading}
              pinCorrect={this.state.pinCorrect}
              errorMessage={this.state.errorMessage}
              getParameter={this.getParameter}
              restart={this.restart}
            />
          ) : (
            <NotLoggedInModal location={location} />
          )}
        </FormCard>
      </Body>
    )
  }
}

export default connect(state => ({
  loggedIn: state.auth.loggedIn
}))(PinsPage)

const NotLoggedInModal = ({ location }) => (
  <div className="pins-body">
    <Markdown source={PIN_NOT_LOGGED_IN_DESCRIPTION} className='markdown description' />
  </div>
)

const PinEntry = ({ checkPin, loading, pinCorrect, successMessage, errorMessage, getParameter, restart }) => (
  <div className="pins-body">
    {pinCorrect ? (
      <div className="success-wrapper">
        {successMessage ?
         (
        <p className='text-success'>
          {successMessage}
        </p>
        )
        :
        ( 
          <p className='text-success'>
            Your PIN has been accepted. Click <strong>Continue</strong> to proceed to My Records to complete filings
            and update information online for your record, or click <strong>Enter Another PIN</strong> if you have
            additional PINs to enter.
          </p> )
    }
        <div className="continue-wrapper">
          <Link className="btn btn-raised" to={`/records${getParameter()}`}>
            Continue
          </Link>
          <button className="btn btn-raised" onClick={restart}>
            Enter Another PIN
          </button>
        </div>
      </div>
    ) : (
      <React.Fragment>
        <Markdown source={PIN_GENERIC_DESCRIPTION} className='markdown description enter-pin-description' />
        <PinInputSection
          onCheckPinRequest={({value}) => checkPin(value)}
          sendValue
          submitDisabled={loading}
          error={
            pinCorrect === false ? (
              <Markdown
                source={
                  errorMessage ||
                  process.env.PIN_PAGE_ERROR ||
                  'The pin you have entered is not valid.'
                }
                className="markdown"
              />
            ) : null
          }
        />
      </React.Fragment>
    )}
  </div>
)



// WEBPACK FOOTER //
// ./src/components/MyRecords/PinsPage.js